import {
  Input,
  InputRef,
  Space,
  Table,
  TableColumnsType,
  Tag,
  Tooltip,
} from 'antd';
import Content from 'layouts/Content';
import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { icons } from 'utils/constants/icons';
import { ModalEditUser } from 'pages';
import ModalViewUser from './ModalViewUser';
import { Button } from 'components';

const { EditOutlined, EyeOutlined } = icons;

interface IProps {
  data: any;
  setData: (data: any) => void;
  edit: boolean;
  setEdit: (data: any) => void;
}

const TableUserPage = forwardRef((props: IProps, ref: any) => {
  const { data, setData, edit, setEdit } = props;
  const newData = {
    key: data.length + 1,
    name: '',
    age: '',
    address: 'New York No. 1 Lake Park',
  };
  const inputRef = useRef<InputRef>(null);
  const [isOpenModalEdit, setIsOpenModalEdit] = useState(false);
  const [isOpenModalView, setIsOpenModalView] = useState(false);
  const [newItem, setNewItem] = useState(newData);

  const columns: TableColumnsType = [
    {
      title: 'Name',
      dataIndex: 'name',
      render: (value: string, record: any, index: number) => {
        return index == 0 && edit ? (
          <Input
            ref={inputRef}
            value={newItem.name}
            name="name"
            onChange={hanldInputChange}
          />
        ) : (
          <a>{value}</a>
        );
      },
    },
    {
      title: 'Age',
      dataIndex: 'age',
      render: (value: string, record: any, index: number) => {
        return index == 0 && edit ? (
          <Input value={newItem.age} name="age" onChange={hanldInputChange} />
        ) : (
          <a>{value}</a>
        );
      },
    },
    {
      title: 'Address',
      dataIndex: 'address',
    },
    {
      title: 'Thao tác',
      fixed: 'right',
      align: 'center',
      width: 100,
      render: (_: any, record: any, i) => {
        return (
          <Space size={'middle'} className="text-lg ">
            {edit && i == 0 ? (
              <Tooltip placement="top" title={'Xem chi tiết'}>
                <EyeOutlined
                  onClick={() => {
                    console.log('object', newItem);
                    setData((pre: any) => [newItem, ...pre.slice(1)]);
                    data[0] = newItem;
                    setEdit(false);
                  }}
                  className="cursor-pointer text-[#00538f]"
                />
              </Tooltip>
            ) : (
              <>
                <Tooltip placement="top" title={'Chỉnh sửa'}>
                  <EditOutlined
                    onClick={() => {
                      // setCurrentUser(record);
                      // setIsPermissionModalVisible(true);
                      console.log('data', data);
                      setIsOpenModalEdit((prev) => !prev);
                    }}
                    className="cursor-pointer text-[#00538f]"
                  />
                </Tooltip>
                <Tooltip placement="top" title={'Xem chi tiết'}>
                  <EyeOutlined
                    onClick={() => {
                      // setCurrentUser(record);
                      // setIsPermissionModalVisible(true);
                      setIsOpenModalView((prev) => !prev);
                    }}
                    className="cursor-pointer text-[#00538f]"
                  />
                </Tooltip>
              </>
            )}
          </Space>
        );
      },
    },
  ];

  useImperativeHandle(ref, () => ({
    handleeAddRow,
  }));

  function handleeAddRow(e: any) {
    setEdit(true);
    setNewItem(newData);
    setData((pre: any) => [newData, ...pre]);
  }

  useEffect(() => {
    if (edit) {
      inputRef.current?.focus({ cursor: 'start' });
    }
  }, [data]);

  const hanldInputChange = (e: any) => {
    const { name, value } = e.target;
    setNewItem((pre) => ({ ...pre, [name]: value }));
  };

  return (
    <Content>
      <Table
        rowKey={(record) => record.id}
        columns={columns}
        scroll={{ x: 1000 }}
        dataSource={data}
        size="middle"
      />
      <ModalEditUser open={isOpenModalEdit} setOpen={setIsOpenModalEdit} />
      <ModalViewUser open={isOpenModalView} setOpen={setIsOpenModalView} />
    </Content>
  );
});

export default memo(TableUserPage);
